import { PencilSquareIcon } from '@heroicons/react/24/outline'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { object, string } from 'yup'

import { Button } from '@/components/Button'
import Label from '@/components/Label'
import Modal from '@/components/Modal'
import TextInput from '@/components/TailwindUI/TextInput'

const partialFeatureSchema = object()
  .shape({
    name: string().required('Data Source Name Required').min(2, 'Name must be at least 2 characters')
  })
  .required()

const initialValues = {
  name: ''
}

interface RenameDataSourceModalProps {
  isOpen?: boolean
  formValues?: Partial<typeof initialValues>
  onSubmit: (values: any) => void
  onClose: () => void
}

const RenameDataSourceModal = ({ isOpen = true, formValues, onSubmit, onClose }: RenameDataSourceModalProps) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: { ...initialValues, ...formValues },
    resolver: yupResolver(partialFeatureSchema)
  })

  const handleClose = () => onClose()

  // default values are cached and must be invalidated whenever they change
  useEffect(() => reset({ ...formValues }), [reset, formValues])

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md" className="max-w-2xl">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mx-8 my-10">
          <div className="flex items-center">
            <PencilSquareIcon className="h-[40px] w-[40px] text-gray-400" aria-hidden="true" />
            <h3 className="ml-3 text-2xl leading-6 text-gray-900">Rename Data Source</h3>
          </div>
          <div className="mt-12">
            <Label htmlFor="name" required>
              Connection Name
            </Label>
            <TextInput
              className="mt-2"
              id="name"
              placeholder="Enter a name to identify your data source"
              error={errors.name?.message}
              {...register('name')}
            />
          </div>
          <div className="mt-12 flex items-center justify-end gap-x-6">
            <Button color="transparent" onClick={() => handleClose()}>
              Cancel
            </Button>
            <Button color="primary">Save</Button>
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default RenameDataSourceModal
